export interface IIngredient {
  [key: string]: number | string | boolean | null
  ingredientId: string
  ingredientName: string
  unit: string
  stock: number
}

export class Ingredient {
  [key: string]: number | string | boolean | null
  ingredientId: string
  ingredientName: string
  unit: string
  stock: number

  constructor({ ingredientId, ingredientName, unit, stock }: Partial<IIngredient>) {
    this.ingredientId = ingredientId || ''
    this.ingredientName = ingredientName || ''
    this.unit = unit || 'KG'
    this.stock = stock || 0
  }
}